<template>
	<v-form ref="form" class="form" lazy-validation>
		<v-container>
			<v-row no-gutters class="row">
				<v-col cols="12" lg="6" :class="$vuetify.breakpoint.lgAndUp ? 'pr-1' : ''">
					<v-text-field
						v-model.trim="component.name"
						:rules="[rules.required]"
						label="部品名(必須)"
						class="mt-4"
						outlined
						dense
					></v-text-field>
				</v-col>
				<v-col cols="12" lg="6" :class="$vuetify.breakpoint.lgAndUp ? 'pl-1' : ''">
					<v-text-field
						v-model.trim="component.part_number"
						:rules="[rules.required]"
						label="品番(必須)"
						class="mt-4"
						outlined
						dense
					/>
				</v-col>
			</v-row>
			<v-row no-gutters class="row">
				<v-col cols="12" lg="6" :class="$vuetify.breakpoint.lgAndUp ? 'pr-1' : ''">
					<v-text-field
						v-model.trim="component.unit_price"
						:rules="[rules.required]"
						label="単価(必須)"
						class="mt-4"
						outlined
						dense
					></v-text-field>
				</v-col>
				<v-col cols="12" lg="6" :class="$vuetify.breakpoint.lgAndUp ? 'pl-1' : ''">
					<v-text-field
						v-model.trim="component.stock"
						:rules="[rules.required]"
						label="現在庫(必須)"
						class="mt-4"
						outlined
						dense
					/>
				</v-col>
			</v-row>

			<v-textarea v-model.trim="component.description" label="説明文" class="mt-4" outlined dense />

			<v-checkbox
				v-model="component.wildcard"
				:true-value="false"
				:false-value="true"
				class="shrink"
				dense
				label="特定の仕様に属する"
			/>
		</v-container>

		<slot name="submit-btn"></slot>
	</v-form>
</template>

<script>
import rules from "../../helper/rules"

export default {
	props: {
		component_data: {
			type: Object,
			required: false,
			default: () => {},
		},
	},
	data() {
		return {
			rules,
		}
	},
	computed: {
		component: {
			get() {
				return this.component_data
			},
			set(newValue) {
				return this.$emit("update:component_data", newValue)
			},
		},
		// setName: {
		// 	get() {
		// 		return this.component.name
		// 	},
		// 	set(newValue) {
		// 		return this.$emit("update:name", newValue)
		// 	},
		// },
		// setPartNumber: {
		// 	get() {
		// 		return this.component.part_number
		// 	},
		// 	set(newValue) {
		// 		return this.$emit("update:part_number", newValue)
		// 	},
		// },
		// setDescription: {
		// 	get() {
		// 		return this.component.description
		// 	},
		// 	set(newValue) {
		// 		return this.$emit("update:description", newValue)
		// 	},
		// },
		// setWildcard: {
		// 	get() {
		// 		return this.component.wildcard
		// 	},
		// 	set(newValue) {
		// 		return this.$emit("update:wildcard", newValue)
		// 	},
		// },
	},
}
</script>
